export default __webpack_public_path__ + "static/media/MO_fab_plan.ec6f4546.png";